<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ this.eventInfo.name }}
    </h1>
    <trashed-message v-if="eventInfo.deleted_at" class="mb-6" @restore="restore">
      This event has been deleted.
    </trashed-message>
    <div class="flex flex-wrap">
      <div class="w-full lg:w-1/2 px-2">

        <card>
          <template v-slot:header>
            Event Summary
          </template>
          <div class="p-6 flex flex-wrap">
            <div class="pb-8 w-full"><span class="font-semibold block">Location:</span>{{ eventInfo.location }}</div>
            <div class="pb-8 w-full lg:w-1/2"><span class="font-semibold block">Start Date:</span>{{ eventInfo.start_date }}</div>
            <div class="pb-8 w-full lg:w-1/2"><span class="font-semibold block">End Date:</span>{{ eventInfo.end_date }}</div>
          </div>

          <template v-slot:footer>
            <button v-if="!eventInfo.deleted_at && can.delete" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Event</button>
            <inertia-link v-if="can.edit" class="btn-indigo ml-auto" :href="route('events.edit', eventInfo.id)">Edit Event</inertia-link>
          </template>
        </card>

        
      </div>
      
      <div class="w-full lg:w-1/2 px-2">
        <card>
          <card-list-item :href="route('attendees.index', eventInfo.id)">
            <span class="font-semibold">Attendees:</span>&nbsp;{{ attendees }}
          </card-list-item>
          <card-list-item :href="route('sessions.index', eventInfo.id)">
            <span class="font-semibold">Sessions:</span>&nbsp;{{ sessions }}
          </card-list-item>
          <card-list-item :href="route('event-reports.index', eventInfo.id)">
            <span class="font-semibold">Reports</span>
          </card-list-item>
          <card-list-item :href="route('attendee-import.index', eventInfo.id)">
            <span class="font-semibold">Import Attendees</span>
          </card-list-item>
        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from "@/Shared/Icon";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Card from '@/Shared/Card/Card'
import CardListItem from '@/Shared/Card/CardListItem'

export default {
  metaInfo() {
    return { title: this.eventInfo.name }
  },
  components: {
    SelectInput,
    TextInput,
    TrashedMessage,
    LoadingButton,
    Icon,
    Card,
    CardListItem,
  },
  props: {
    eventInfo: Object,
    attendees: Number,
    sessions: Number,
    can: Object,
  },
  layout: Layout,
  data() {
    return {
    }
  },
  methods: {
    update() {
      this.eventInfo.put(this.route('events.update', this.eventInfo.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this event?')) {
        this.$inertia.delete(this.route('events.destroy', this.eventInfo.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this event?')) {
        this.$inertia.put(this.route('events.restore', this.eventInfo.id))
      }
    },
  },
}
</script>
